module.exports = __webpack_public_path__ + "static/ei.a1f4e72f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ei.jpg
// module id = 749
// module chunks = 139266963665775